<template>
    <form class="account-info-form" @submit.prevent="save">
        <div class="flex flex-col md:flex-row gap-4 lg:gap-8">
            <app-input
                type="text"
                v-model="form.first_name"
                :message="errors.get('first_name')"
                label="inputs.firstName"
            />

            <app-input
                type="text"
                v-model="form.last_name"
                :message="errors.get('last_name')"
                label="inputs.lastName"
            />
        </div>

        <app-input
            type="tel"
            v-model="form.id_number"
            :message="errors.get('id_number')"
            readonly
            label="inputs.idNumber"
        />

        <date-input
            v-model="form.id_issued"
            :message="errors.get('id_issued')"
            label="inputs.id_issued"
        />

        <app-input
            type="tel"
            v-model="form.phone_number"
            readonly
            :message="errors.get('phone_number')"
            label="inputs.phoneNumber"
        />

        <app-input
            type="text"
            v-model="form.email"
            :message="errors.get('email')"
            label="inputs.email"
        />

        <app-autocomplete-input
            label="inputs.city"
            :message="
                errors.get('address.city.value') ||
                    errors.get('address.city.label')
            "
            :search-cb="searchCities"
            @reset="resetCity"
            v-model="form.address.city"
        />

        <app-autocomplete-input
            label="inputs.street"
            :message="
                errors.get('address.street.value') ||
                    errors.get('address.street.label')
            "
            :search-cb="searchStreets"
            :disabled="!form.address.city"
            v-model="form.address.street"
        />

        <div class="numbers">
            <app-input
                type="tel"
                v-model="form.address.number"
                :message="errors.get('address.number')"
                label="inputs.number"
            />

            <app-input
                type="tel"
                v-model="form.address.apartment"
                :message="errors.get('address.apartment')"
                label="inputs.apartment"
            />
        </div>

        <div class="spacer"></div>

        <div class="submit submit-unit lg:self-center lg:col-span-2">
            <span>
                <app-button :loading="saving">{{
                    "inputs.save" | __
                }}</app-button>
            </span>
            <span>
                <transition name="fade">
                    <p class="msg" v-if="show">הפרטים עודכנו</p>
                </transition>
            </span>
        </div>
    </form>
</template>

<script>
import AppInput from "./Forms/Input";
import DateInput from "./Forms/DateInput";
import AppButton from "./Forms/Button";
import AppAutocompleteInput from "./Forms/AutocomplateInput";

export default {
    components: { AppAutocompleteInput, AppButton, AppInput, DateInput },

    props: {
        user: Object
    },

    data() {
        return {
            saving: false,
            form: this.user,
            errors: this.$api.errors(),
            el: "#fade",
            show: false
        };
    },

    methods: {
        resetCity() {
            this.form.address.city = undefined;
            this.form.address.street = undefined;
        },
        async searchCities(term) {
            if (!term) {
                return [];
            }

            const res = await this.$api.get("address/city/search?q=" + term);
            const items = res.data();

            return (items || []).map(city => ({
                value: city.code,
                id: city.id,
                label: city.name
            }));
        },

        async searchStreets(term) {
            const cityId = this.form.address.city.id;

            if (!term || !cityId) {
                return [];
            }

            const res = await this.$api.get(
                "address/street/" + cityId + "/search?q=" + term
            );
            const items = res.data();

            return (items || []).map(city => ({
                value: city.code,
                id: city.id,
                label: city.name
            }));
        },

        async save() {
            this.saving = true;

            const res = await this.$api.post("account", this.form);
            this.errors = res.errors();

            this.saving = false;
            this.show = true;

            setTimeout(() => {
                this.show = false;
            }, 2000);
        }
    }
};
</script>

<style lang="scss" scoped>
.account-info-form {
    display: grid;
    grid-template-columns: 45% 45%;
    max-width: $tablet;
    margin: auto;
    column-gap: 10%;
    row-gap: 50px;

    @media all and (max-width: $desktop) {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .numbers {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr;
        gap: 0 33px;

        @media all and (max-width: $tablet) {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }
    }
}

.app-date-input,
.app-input {
    &.app-input {
        ::v-deep [readonly] {
            background-color: $light-gray;
        }
    }

    ::v-deep {
        .vdp-datepicker input,
        input {
            border: solid 1px $blue-gray !important;
            background-color: $white;
            padding: 0 20px !important;
        }

        label {
            font-size: 15px;
            font-weight: bold;
        }

        .line {
            display: none !important;
        }

        .message {
            margin-top: 4px;
        }
    }
}

.submit {
    display: flex;
    align-items: center;
    justify-content: center;
    display: block;
    text-align: center;

    &.submit-unit {
        @media all and (max-width: $mobile) {
            margin-top: 20px;
        }
    }
}

.app-autocomplete-input {
    // border: solid 1px $blue-gray !important;
    // background-color: $white;

    ::v-deep {
        .app-input {
            border: none;

            input {
                background: $white;
                border: solid 1px $blue-gray !important;
            }
        }

        .line {
            display: none;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.app-button {
    margin-top: 10px;
}

.msg {
    margin: 10px 10px 10px 10px;
    text-align: center;
    font-size: 24px;
}
</style>
